var modalButton = document.querySelector('.new-comment-button'),
    modal = document.querySelector('.comment-form'),
    modalBackground = document.querySelector('.modal-background'),
    submitButton = document.querySelector('.submit');

if (modalButton !== null) {
    modalButton.addEventListener('click', function (event) {
        if (modal !== null) {
            if (modal.style.display === 'none') {
                modal.style.display = 'flex';
                modalBackground.style.display = 'block';
            } else {
                modal.style.display = 'none';
                modalBackground.style.display = 'none';
            }
        }
    });
}

if (modalBackground !== null) {
    modalBackground.addEventListener('click', function () {
        if (modal !== null) {
            modal.style.display = 'none';
            modalBackground.style.display = 'none';
        }
    });
}

if (modal !== null) {
    modal.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
    });
}

if (submitButton !== null) {
    submitButton.addEventListener('click', function (event) {
        if (modal !== null) {
            modal.submit();
        }
    });
}
